export default function componentStyleOverrides(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: `${0}px`
        },
        contained: {
          backgroundColor: theme.primaryMain,
          color: theme.colors?.black,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.primaryMain,
            opacity: 0.8
          }
        }
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: theme.backgroundSurface
        },
        rounded: {
          borderRadius: `${0}px`
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.secondaryMain,
          color: '#fff'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: theme.secondaryMain
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          color: theme.colors?.textDark,
          padding: '24px'
        },
        title: {
          fontSize: '1.125rem'
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          paddingTop: '10px',
          paddingBottom: '10px',
          '&.Mui-selected': {
            // color: theme.menuSelected,
            backgroundColor: theme.primary200,
            '&:hover': {
              // backgroundColor: theme.menuSelectedBack
            },
            '& .MuiListItemIcon-root': {
              color: theme.darkTextPrimary
            }
          },
          '&:hover': {
            // backgroundColor: theme.menuSelectedBack,
            // color: theme.menuSelected,
            '& .MuiListItemIcon-root': {
              color: theme.darkTextPrimary
            }
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          minWidth: '36px'
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: theme.textDark
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: theme.textDark,
          '&::placeholder': {
            color: theme.darkTextSecondary,
            fontSize: '0.875rem'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: `${0}px`,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.grey400
          },
          '&:hover $notchedOutline': {
            borderColor: theme.colors?.divider
          },
          '&.MuiInputBase-multiline': {
            padding: 1
          }
        },
        input: {
          fontWeight: 500,
          //  background: bgColor,
          padding: '15.5px 14px',
          borderRadius: `${0}px`,
          '&.MuiInputBase-inputSizeSmall': {
            padding: '10px 14px',
            '&.MuiInputBase-inputAdornedStart': {
              paddingLeft: 0
            }
          }
        },
        inputAdornedStart: {
          paddingLeft: 4
        },
        notchedOutline: {
          borderRadius: `${0}px`
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: `${0}px`,
          '&::before': {
            borderBottomColor: theme.colors?.divider
          }
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: theme.colors?.grey300
          }
        },
        mark: {
          backgroundColor: theme.paper,
          width: '4px'
        },
        valueLabel: {
          color: theme?.colors?.primaryLight
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.divider,
          opacity: 1
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          color: theme.colors?.primaryDark,
          background: theme.colors?.primary200
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-deletable .MuiChip-deleteIcon': {
            color: 'inherit'
          }
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.colors.white,
          background: theme.colors?.grey700
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
          fontSize: '1.25rem',
          color: theme.colors?.textDark,
          fontWeight: 600
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          fontSize: '1rem'
        }
      }
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: theme.textPrimary
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          backgroundColor: theme.backgroundDefault,
          borderRadius: `${0}px`,

          '&.Mui-selected': {
            backgroundColor: theme.colors?.secondaryDark
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.colors?.secondaryDark
          },
          '&:hover': {
            backgroundColor: theme.colors?.secondaryDark
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: theme.colors?.secondaryDark
        },
        body: {
          backgroundColor: theme.backgroundDefault
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        row: {
          backgroundColor: theme.backgroundDefault,
          '&:hover': {
            backgroundColor: theme.secondaryDark
          }
        },
        columnHeader: {
          backgroundColor: theme.colors?.secondaryDark
        }
      }
    }
  }
}
